var map = {
	"./ar/pupchase.png": "8187",
	"./de/pupchase.png": "9dd3",
	"./en/pupchase.png": "4588",
	"./es/pupchase.png": "c9ef",
	"./fr/pupchase.png": "d677",
	"./pt/pupchase.png": "822e",
	"./ru/pupchase.png": "e2d7",
	"./zh/pupchase.png": "c498"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba75";